import React, { FC, useEffect, useState } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import { FormattedMessage, useIntl } from 'react-intl';

import { RawSearchBar } from '../../../../../../search/components/search-bar/SearchBar';
import { PrimaryButton } from '../../../../../../components/button';

import { buildSearchModalURL } from '../../utils/utils';
import { placeholderMap } from '../../utils/constants';

import styles from './search_bar_section.module.scss';

type Props = {
  articleIds: string[];
  modal: string;
  type: string;
  filterValue: string | { legislativeFolder: string };
  queryFromState: string;
  shouldPersistQuery: boolean;
  onClearClicked: Function;
};

export const SearchBarSection: FC<Props> = ({
  articleIds,
  modal,
  type,
  filterValue,
  queryFromState,
  shouldPersistQuery,
  onClearClicked,
}) => {
  const intl = useIntl();
  const history = useHistory();
  const { pathname, search } = useLocation();
  const searchParams = new URLSearchParams(search);
  const [query, setQuery] = useState<string>('');

  useEffect(() => {
    if (shouldPersistQuery) setQuery(queryFromState);
  }, [queryFromState]);

  const onSearchBtnClick = (q: string) => {
    const versionParam = searchParams.get('version');

    history.push({
      pathname,
      search: buildSearchModalURL({
        query: q,
        type,
        articleIds,
        modal,
        version: versionParam || '',
        filterValue,
      }),
    });
  };

  return (
    <>
      <div className={styles.section}>
        <div className={styles.container}>
          <RawSearchBar
            enableTypeSelector={false}
            activateScrollToTop={false}
            query={query}
            onUserType={(newQuery) => setQuery(newQuery)}
            onQueryPaste={(newQuery) => setQuery(newQuery)}
            submitCurrentQuery={onSearchBtnClick}
            followAutocomplete={onSearchBtnClick}
            allowEmptyQuery
            onClearClicked={() => {
              // We reset the query if the user clear it.
              setQuery('');
              onClearClicked();
            }}
            placeholder={
              placeholderMap[type] &&
              intl.formatMessage({
                id: placeholderMap[type],
              })
            }
          />
        </div>
        <div className={styles.btn}>
          <PrimaryButton
            onClick={() => onSearchBtnClick(query)}
            data-test-id="search-btn"
          >
            <FormattedMessage id="page/article/components/SearchBarSection.tsx/1" />
          </PrimaryButton>
        </div>
      </div>
    </>
  );
};
